'use strict';

var Params = function Params(containerWidth, containerHeight) {
  var padding = {
    top: 20,
    bottom: 25,
    left: 50,
    right: 80
  };
  var height = 60;
  var width = containerWidth - (padding.left + padding.right);
  return {
    width: width,
    forceHeight: true,
    height: height,
    containerWidth: containerWidth,
    containerHeight: height + padding.top + padding.bottom,
    padding: padding,
    xAxisShift: 0,
    direction: 'vertical',
    yAxisShift: 0,
    yNumberOfTicks: 3,
    graphAlign: 'left'
  };
};
module.exports = Params;